import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';


import { IconButton, Switch, Tooltip } from '@mui/material';


const CalendarsRow = ({ row, updateForm, onDelete, index, handleActive }) => {

  // "Teste Gui Calendario"
  // FridayEnd
  // FridayStart
  // IdEngineCalendar

  // MondayEnd
  // MondayStart
  // SaturdayEnd
  // SaturdayStart
  // SundayEnd
  // SundayStart
  // ThursdayEnd
  // ThursdayStart

  // TuesdayEnd

  // TuesdayStart

  // WednesdayEnd
  // WednesdayStart

  const convertString = (str) => {
    if (!str.includes('-'))
      return str.slice(0, 2) + ":" + str.slice(2)
    else
      return str
  }

  return (
    <>
      <TableCell component="th" align="center" scope="row" key={index}>
        {row.IdEngineCalendar}
      </TableCell>
      <TableCell align="center" key={index}>{row.Calendar}</TableCell>
      <TableCell align="center" key={index}>{convertString(row.SundayStart)} - {convertString(row.SundayEnd)}</TableCell>
      <TableCell align="center" key={index}>{convertString(row.MondayStart)} - {convertString(row.MondayEnd)}</TableCell>
      <TableCell align="center" key={index}>{convertString(row.TuesdayStart)} - {convertString(row.TuesdayEnd)}</TableCell>
      <TableCell align="center" key={index}>{convertString(row.WednesdayStart)} - {convertString(row.WednesdayEnd)}</TableCell>
      <TableCell align="center" key={index}>{convertString(row.ThursdayStart)} - {convertString(row.ThursdayEnd)}</TableCell>
      <TableCell align="center" key={index}>{convertString(row.FridayStart)} - {convertString(row.FridayEnd)}</TableCell>
      <TableCell align="center" key={index}>{convertString(row.SaturdayStart)} - {convertString(row.SaturdayEnd)}</TableCell>
      <TableCell align="center">
        <Switch checked={Boolean(Number(row.Active))} onChange={(e, value) => { handleActive(row.IdEngineCalendar, value) }} />
      </TableCell>

      <TableCell align="center" key={index}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete">
          <IconButton onClick={() => { onDelete(row.IdEngineCalendar) }}>
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default CalendarsRow;